<template>
  <div class="container-fluid">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
      <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="col-sm p-0">
        <div class="account">
          <div class="container-page">
            <div style="font-weight: 700; color: #1D3354;" class="header">My Accounts</div>
            <div class="content">
              <div class="row">
                <div class="col-md-3 pr-0 pl-0">
                  <div class="photosection">
                    <img
                      @click="selectProfilePict"
                      :src="photo"
                      style="max-width:60%; max-height:30%; margin: 30px auto 20px auto; display: block; padding-top: 20px; cursor: pointer;"
                      v-if="photo && !isLoading"
                    />
                    <span v-else-if="isLoading"
                      ><b-spinner
                        small
                        variant="secondary"
                        label="Spinning"
                        style="margin: 50px 0 50px 115px;"
                    /></span>
                    <img
                      @click="selectProfilePict"
                      class="__noAvatar"
                      src="@/assets/image/no-pict-default.png"
                      style="max-width:60%; max-height:30%; margin: 30px auto 20px auto; display: block; padding-top: 20px; cursor: pointer;"
                      v-else-if="!photo && !isLoading"
                    />
                    <!-- <img
                      :src="photo || '@/assets/image/image/basic.png'"
                      width="170;"
                      height="170"
                      alt=""
                      style="margin: 30px 37px 20px"
                    /> -->
                    <form class="ml-4" style="margin: 20px auto 20px auto;">
                      <div style="display:none" class="row __uploadbox--choose">
                        <input
                          type="file"
                          name="myfile"
                          id="fileUploadProfilePicture"
                          ref="fileDocument"
                          v-on:change="handleFileUpload()"
                          accept="image/jpeg, image/png, image/gif, image/jpg"
                        />
                        <p>{{ filename }}</p>
                      </div>
                    </form>
                    <div class="mt-2 d-flex justify-content-center">
                      <button
                        class="button__bluesmall"
                        style="margin-bottom: 20px;"
                        @click="uploadPhoto()"
                      >
                        +Add Picture
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-9 pl-0 accountsform">
                  <form @submit.prevent="">
                    <div class="d-flex mb-2">
                      <div
                        class="input__model1group marginright3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Full Name</p>
                        <b-form-input
                          v-model="form.fullname"
                          name="Industry Others"
                          v-validate="'required'"
                          placeholder="John Doe"
                        />
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Industry Others") }}
                        </div>
                      </div>
                      <div
                        class="input__model1group marginright3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Company Name</p>
                        <b-form-input
                          v-model="form.companyName"
                          name="Company Name"
                          v-validate="'required'"
                          placeholder="PT Kenangan Indah"
                        />
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Company Name") }}
                        </div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div
                        class="input__model1group marginright3 mt-3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Gender</p>
                        <div class="options__multipleselect">
                          <multiselect
                            v-model="selectedGender"
                            :options="genderOptions"
                            label="text"
                            placeholder="Select Gender"
                            v-validate="'required'"
                            name="Gender"
                            @input="inputSelectGender"
                            :allow-empty="false"
                            :show-labels="false"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/icon-arrow-blue.png"
                          />
                        </div>
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Gender") }}
                        </div>
                      </div>
                      <div class="input__model1group mt-3" style="width: 48.5%">
                        <p style="font-weight: bold;" class="input-label">Email Company</p>
                        <b-form-input
                          v-model="form.email"
                          name="Email Company"
                          v-validate="'required'"
                          placeholder="shipment@kenangan.com"
                        />
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Email Company") }}
                        </div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div
                        class="input__model1group marginright3 mt-3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Phone Number</p>
                        <div class="d-flex m-0">
                          <div
                            class="modifyoptionphone marginright3"
                            style="width: 30%"
                          >
                            <div class="options__multipleselect">
                              <multiselect
                                v-model="selectedPhoneCode"
                                :options="phoneOptions || []"
                                @input="inputSelectPhoneCode"
                                :custom-label="customPhoneLabel"
                                placeholder="+62"
                                :allow-empty="false"
                                :show-labels="false"
                              >
                                <span slot="noResult"
                                  >Oops! No elements found.</span
                                >
                              </multiselect>
                              <img
                                class="options__multipleselect--imgabsolute"
                                src="@/assets/image/icon/icon-arrow-blue.png"
                              />
                            </div>
                            <div class="fontstyle__errormsg">
                              {{ errors.first("Phone Code") }}
                            </div>
                          </div>
                          <div class="col-md pl-2 pr-0" style="width: 66%">
                            <b-form-input
                              v-model="form.phone"
                              type="number"
                              name="Phone Number"
                              v-validate="'required'"
                              placeholder="E.g: 8771234xxxxx"
                            />
                            <div class="fontstyle__errormsg">
                              {{ errors.first("Phone Number") }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="input__model1group marginright3 mt-3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Job Title</p>
                        <b-form-input
                          v-model="form.job"
                          name="Job Title"
                          v-validate="'required'"
                          placeholder="Staff"
                        />
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Job Title") }}
                        </div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div
                        class="input__model1group marginright3 mt-3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Company Address</p>
                        <b-form-textarea
                          v-model="form.companyAddress"
                          name="Company Address"
                          type="text"
                          v-validate="'required'"
                          placeholder="Jl. Mega Kuningan Barat, Blok E.4.7,"
                          rows="5"
                          max-rows="6"
                          style="max-height: 105px"
                        />
                        <div
                          class="fontstyle__errormsg"
                          v-if="errors.first('Company Address')"
                        >
                          {{ errors.first("Company Address") }}
                        </div>
                        <div
                          style="color: #ffffff; font-size: 12px"
                          class="mt-1"
                          v-else
                        >
                          Address needs to be the same with NPWP/Incorporation
                          Certificate
                        </div>
                      </div>

                      <div style="width: 50%" class="dropdowncustom mb-1">
                        <div class="input__model1group marginright3 mt-3">
                          <p style="font-weight: bold;" class="input-label">Company Size</p>
                          <div class="options__multipleselect">
                            <multiselect
                              v-model="selectedSize"
                              :options="sizeOption || []"
                              label="name"
                              placeholder="Select Company Size"
                              name="Company Size"
                              :allow-empty="false"
                              :show-labels="false"
                            >
                              <span slot="noResult"
                                >Oops! No elements found.</span
                              >
                            </multiselect>
                            <img
                              class="options__multipleselect--imgabsolute"
                              src="@/assets/image/icon/icon-arrow-blue.png"
                            />
                          </div>
                          <div class="fontstyle__errormsg">
                            {{ errors.first("Company Size") }}
                          </div>
                        </div>
                        <div
                          class="input__model1group marginright3 mt-3"
                        >
                          <p style="font-weight: bold;" class="input-label">City</p>
                          <div class="options__multipleselect">
                            <multiselect
                              v-model="selectedCity"
                              :options="optionCity || []"
                              label="name"
                              placeholder="Select City"
                              v-validate="'required'"
                              name="City"
                              :allow-empty="false"
                              :show-labels="false"
                            >
                              <span slot="noResult"
                                >Oops! No elements found.</span
                              >
                            </multiselect>
                            <img
                              class="options__multipleselect--imgabsolute"
                              src="@/assets/image/icon/icon-arrow-blue.png"
                            />
                          </div>
                          <div class="fontstyle__errormsg">
                            {{ errors.first("City") }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex">
                      <div
                        class="input__model1group marginright3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Country</p>
                        <div class="options__multipleselect">
                          <multiselect
                            v-model="selectedCountry"
                            :options="optionCountry || []"
                            label="name"
                            v-validate="'required'"
                            placeholder="Select Country"
                            name="Country"
                            :allow-empty="false"
                            :show-labels="false"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/icon-arrow-blue.png"
                          />
                        </div>
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Country") }}
                        </div>
                      </div>
                      <div
                        class="input__model1group marginright3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Sales Person</p>
                        <div class="options__multipleselect">
                          <multiselect
                            v-model="selectedSales"
                            :options="salesList || []"
                            label="name"
                            placeholder="Select Salesperson"
                            name="Salesperson"
                            disabled
                            :allow-empty="false"
                            :show-labels="false"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <!-- <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/icon-arrow-blue.png"
                          /> -->
                        </div>
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Sales Person") }}
                        </div>
                      </div>
                      <!-- <div
                        class="input__model1group marginright3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Province</p>
                        <div class="options__multipleselect">
                          <multiselect
                            v-model="selectedProvince"
                            :options="optionProvince || []"
                            label="name"
                             placeholder="Select Salesperson"
                            name="Salesperson"
                            @input="inputSelectProvince"
                            :allow-empty="false"
                            :show-labels="false"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/icon-arrow-blue.png"
                          />
                        </div>
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Province") }}
                        </div>
                      </div> -->
                      <!-- <div
                        class="input__model1group marginright3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">City</p>
                        <div class="options__multipleselect">
                          <multiselect
                            v-model="selectedCity"
                            :options="optionCity || []"
                            label="name"
                            placeholder="Select Salesperson"
                            name="Salesperson"
                            @input="inputSelectCity"
                            :allow-empty="false"
                            :show-labels="false"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/icon-arrow-blue.png"
                          />
                        </div>
                        <div class="fontstyle__errormsg">
                          {{ errors.first("City") }}
                        </div>
                      </div> -->
                    </div>

                    <!-- <div class="d-flex">
                      <div
                        class="input__model1group marginright3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">District</p>
                        <div class="options__multipleselect">
                          <multiselect
                            v-model="selectedDistrict"
                            :options="optionDistrict || []"
                            label="name"
                            placeholder="Select Salesperson"
                            name="Salesperson"
                            @input="inputSelectDistrict"
                            :allow-empty="false"
                            :show-labels="false"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/icon-arrow-blue.png"
                          />
                        </div>
                        <div class="fontstyle__errormsg">
                          {{ errors.first("District") }}
                        </div>
                      </div>
                      <div
                        class="input__model1group marginright3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Sub-District</p>
                        <div class="options__multipleselect">
                          <multiselect
                            v-model="selectedSubdistrict"
                            :options="optionSubdistrict || []"
                            label="name"
                            placeholder="Select Salesperson"
                            name="Salesperson"
                            @input="inputSelectSubdistrict"
                            :allow-empty="false"
                            :show-labels="false"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/icon-arrow-blue.png"
                          />
                        </div>
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Sub-District") }}
                        </div>
                      </div>
                    </div> -->

                    <div class="d-flex mb-2">
                      <!-- <div
                        class="input__model1group marginright3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Post Code</p>
                        <b-form-input
                          type="number"
                          v-model="form.postCode"
                          name="Industry Others"
                          v-validate="'required'"
                          placeholder="12950"
                        />
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Post Code") }}
                        </div>
                      </div> -->
                      <!-- widthnya 48 % -->
                      <div
                        class="input__model1group marginright3 mt-3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Post Code</p>
                        <b-form-input
                          type="number"
                          v-model="form.postCode"
                          name="Post Code"
                          v-validate="'required'"
                          placeholder=" "
                        />
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Post Code") }}
                        </div>
                      </div>
                      <!-- <div
                        class="input__model1group marginright3 mt-3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Industry Type</p>
                        <div class="options__multipleselect">
                          <multiselect
                            v-model="selectedType"
                            :options="getListIndustry || []"
                            label="name"
                            placeholder="Select Industry Type"
                            name="Industry Type"
                            @input="inputSelectType"
                            :allow-empty="false"
                            :show-labels="false"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/icon-arrow-blue.png"
                          />
                        </div>
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Industry Type") }}
                        </div>
                      </div> -->
                      <div
                        class="input__model1group marginright3 mt-3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Yearly Revenue</p>
                        <div class="options__multipleselect">
                          <multiselect
                            v-model="selectedRevenue"
                            :options="optionRevenue || []"
                            label="name"
                            placeholder="Select Revenue"
                            name="Yearly Revenue"
                            @input="inputSelectYearlyRevenue"
                            :allow-empty="false"
                            :show-labels="false"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/icon-arrow-blue.png"
                          />
                        </div>
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Yearly Revenue") }}
                        </div>
                      </div>
                    </div>

                    <div class="d-flex mb-2">
                       <div
                        class="input__model1group marginright3 mt-3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Company Trade Role</p>
                        <!-- {{ selectedTradeRole }} {{ form.companyTradeRole }} -->
                        <div class="options__multipleselect">
                          <multiselect
                            v-model="selectedTradeRole"
                            :options="getListTradeRole || []"
                            label="name"
                            placeholder="Select Company Trade Role"
                            name="Industry"
                            :allow-empty="false"
                            :show-labels="false"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/icon-arrow-blue.png"
                          />
                        </div>
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Company Trade Role") }}
                        </div>
                      </div>
                      <div
                        class="input__model1group marginright3 mt-3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Company Industry Type</p>
                        <div class="options__multipleselect">
                          <multiselect
                            v-model="selectedIndustry"
                            :options="getListIndustry || []"
                            label="name"
                            placeholder="Select Company Industry Type"
                            name="Industry"
                            :allow-empty="false"
                            :show-labels="false"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/icon-arrow-blue.png"
                          />
                        </div>
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Company Industry Type") }}
                        </div>
                      </div>
                    </div>

                    <div class="d-flex mb-2">
                       <div
                        class="input__model1group marginright3 mt-3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">NPWP Number</p>
                        <b-form-input
                          v-model="form.npwp"
                          name="NPWP Number"
                          v-validate="'required'"
                          maxlength="20"
                          placeholder="-"
                          @input="formatNpwp(form.npwp)"
                        />
                        <div class="fontstyle__errormsg">
                          {{ errors.first("NPWP Number") }}
                        </div>
                      </div>
                      <div
                        v-if="selectedIndustry && selectedIndustry.name === 'Others'"
                        class="input__model1group marginright3 mt-3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Others</p>
                        <b-form-input
                          v-model="form.industryOthers"
                          name="Industry Others"
                        />
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Industry Others") }}
                        </div>
                      </div>
                    </div>

                    <div class="d-flex mb-2">
                      <div
                        class="input__model1group marginright3 mt-3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">Terms of Payment</p>
                        <b-form-input
                          v-model="form.termofpayment"
                          name="Term of Payment"
                          v-validate="'required'"
                          placeholder="14 Days"
                          disabled
                        />
                        <div class="fontstyle__errormsg">
                          {{ errors.first("Term of Payment") }}
                        </div>
                      </div>
                      <!-- <div
                        class="input__model1group marginright3"
                        style="width: 48.5%"
                      >
                        <p style="font-weight: bold;" class="input-label">NPWP Number</p>
                        <b-form-input
                          v-model="form.npwp"
                          name="Fullname"
                          v-validate="'required'"
                          placeholder="-"
                        />
                        <div class="fontstyle__errormsg">
                          {{ errors.first("NPWP Number") }}
                        </div>
                      </div> -->
                    </div>
                    <div class="d-flex justify-content-end">
                      <button
                        @click="toEditAccount"
                        class="button__bluemed ml-3 mr-3 mt-5"
                        style=""
                      >
                         <span v-if="isLoadingEditAccount">
                          <b-spinner small variant="light" label="Spinning" />
                        </span>
                        <span v-else>
                          Save
                        </span>
                      </button>
                    </div>
                    <div class="d-flex justify-content-end">
                      <p class="font-italic" v-if="resultEdit === 'success'">
                        Succesfully Updated!
                      </p>
                      <p
                        class="font-italic text-danger"
                        v-if="resultEdit !== 'success'"
                      >
                        {{ resultEdit }}
                      </p>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!--password setting section-->

            <div class="header mt-4">
              <div class="row">
                <div class="col-md-3">
                  <p style="margin-top: 37px">Password Settings</p>
                </div>
                <div class="col-md-8 accountsform">
                  <div class="d-flex mt-3">
                    <ValidationObserver ref="observerpwd">
                      <form
                        slot-scope="{ validate }"
                        @submit.prevent="validate().then(changePassword)"
                      >
                        <div class="row">
                          <div class="password-change">
                            <ValidationProvider
                              name="new password"
                              rules="required|verify_password"
                            >
                              <b-form-group
                                class="mb-1"
                                slot-scope="{ errors }"
                                label="Reset Password"
                              >
                                <div class="passwordvalue-change ">
                                  <b-form-input
                                    v-model="formPassword.resetpwd"
                                    v-bind:type="fieldTypePass1"
                                    placeholder="Enter Your New Password"
                                  ></b-form-input>
                                  <div
                                    class="toggle-password"
                                    @click="togglePassword1"
                                  >
                                    <img
                                      class="passwordvalue-change__eyesabsolute-change"
                                      src="@/assets/image/icon/icon-eye-slash.png"
                                      v-if="fieldTypePass1 == 'password'"
                                    />
                                    <img
                                      class="passwordvalue-change__eyesabsolute-change open"
                                      src="@/assets/image/icon/icon-eye.png"
                                      v-if="fieldTypePass1 == 'text'"
                                    />
                                  </div>
                                </div>
                                <div>
                                  <div
                                    v-if="
                                      errors &&
                                        errors.length &&
                                        !isUpdatedPass &&
                                        formPassword.resetpwd
                                    "
                                    class="fontstyle__errormsg"
                                  >
                                    {{ errors[0] }}
                                  </div>
                                  <div
                                    v-else-if="
                                      !formPassword.resetpwd && !pass_alert_msg
                                    "
                                    style="font-size: 12px"
                                  >
                                    Use 8 or more characters with a mix of small
                                    and capital letters, and numbers.
                                  </div>
                                  <div
                                    v-if="
                                      !errors &&
                                        !errors.length &&
                                        !formPassword.resetpwd
                                    "
                                    class="fontstyle__successmsg"
                                  ></div>
                                </div>
                              </b-form-group>
                            </ValidationProvider>
                          </div>
                          <div class="password-change">
                            <ValidationProvider
                              name="password confirmation"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <b-form-group
                                class="mb-1"
                                label="Password Confirmation"
                              >
                                <div class="passwordvalue-change">
                                  <b-form-input
                                    v-model="formPassword.confpwd"
                                    v-bind:type="fieldTypePass2"
                                    placeholder="Enter Password Confirmation"
                                  ></b-form-input>
                                  <div
                                    class="toggle-password"
                                    @click="togglePassword2"
                                  >
                                    <img
                                      class="passwordvalue-change__eyesabsolute-change"
                                      src="@/assets/image/icon/icon-eye-slash.png"
                                      v-if="fieldTypePass1 == 'password'"
                                    />
                                    <img
                                      class="passwordvalue-change__eyesabsolute-change open"
                                      src="@/assets/image/icon/icon-eye.png"
                                      v-if="fieldTypePass1 == 'text'"
                                    />
                                  </div>
                                </div>
                              </b-form-group>
                              <div
                                v-if="
                                  errors &&
                                    errors.length &&
                                    !isUpdatedPass &&
                                    formPassword.confpwd
                                "
                                class="fontstyle__errormsg"
                              >
                                {{ errors[0] }}
                              </div>
                              <div
                                v-else-if="
                                  formPassword.confpwd &&
                                    formPassword.resetpwd !==
                                      formPassword.confpwd
                                "
                                class="text-left fontstyle__errormsg"
                              >
                                Passwords do not match.
                              </div>
                            </ValidationProvider>
                          </div>
                        </div>
                      </form>
                    </ValidationObserver>
                  </div>
                </div>
                <div class="col-md-1 mt-3">
                  <div class="d-flex justify-content-end">
                    <button
                      @click.prevent="changePassword"
                      type="submit"
                      class=" button__bluesmall px-3 py-2 mt-4 mr-3"
                    >
                       <span v-if="isLoadingChangePassword">
                          <b-spinner small variant="light" label="Spinning" />
                        </span>
                        <span v-else>
                          Save
                        </span>
                    </button>
                  </div>
                  <div
                    class="__updateMsg pr-1"
                    style="font-size: 12px"
                    v-if="pass_alert_msg"
                  >
                    <p>{{ pass_alert_msg }}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- User section -->
            <div class="header mt-4 d-flex justify-content-between">
              Account User
              <div class="d-flex justify-content-end mr-3">
                <button
                  class="button__formblue"
                  @click.prevent="invite()"
                  :disabled="profile.status !== 'ANDALINVERIFICATION'"
                >
                  +add member
                </button>
              </div>
            </div>
            <div class="content usersettings">
              <form>
                <div>
                  <tr class="w-100 d-flex justify-content-between mb-2">
                    <td style="width: 35%">Username Email</td>
                    <td style="width: 23%">Full Name</td>
                    <td style="width: 25%">User's position</td>
                    <td style="width: 13%">Status</td>
                  </tr>

                  <tr
                    v-for="(user, i) in usersList"
                    :key="user.id"
                    class="w-100 d-flex justify-content-between"
                  >
                    <td style="width: 35%">
                      <p>{{ user.username }}</p>
                    </td>
                    <td style="width: 23%">
                      <p>{{ user.fullname }}</p>
                    </td>
                    <td style="width: 25%">
                      <div
                        class="input__model1group marginright3"
                        style="width: 121px"
                      >
                        <div class="options__multipleselect">
                          <multiselect
                            :value="user.selectedPosition"
                            :options="optionPosition || []"
                            label="text"
                            @input="positionSelect($event, i)"
                            placeholder="Admin"
                            name="Position"
                            :selected-label="String(user.codeusertype)"
                            :allow-empty="false"
                            :show-labels="false"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/icon-arrow-blue.png"
                          />
                        </div>
                      </div>
                    </td>
                    <td style="width: 13%">
                      <div
                        class="input__model1group marginright3"
                        style="width: 121px"
                      >
                        <div class="options__multipleselect">
                          <multiselect
                            :value="user.selectedUserStatus"
                            :options="optionUserStatus || []"
                            label="text"
                            @input="userSelectStatus($event, i)"
                            placeholder="active"
                            name="Salesperson"
                            :selected-label="String(user.statverif)"
                            :allow-empty="false"
                            :show-labels="false"
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/icon-arrow-blue.png"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <div class="d-flex justify-content-end">
                    <button class="button__bluemed mr-3 mt-3">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import { mapGetters } from 'vuex'
import { setTimeout } from 'timers'
import mixin from '@/mixin'
import ConfigPassword from '@/mixin/getters/config-password'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
export default {
  name: 'MyAccount',
  components: {
    Sidebar,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      fieldTypePass1: 'password',
      fieldTypePass2: 'password',
      formPassword: {
        resetpwd: '',
        confpwd: ''
      },
      isUpdatedPass: false,
      pass_alert_msg: '',
      isActive: false,
      submitted: false,
      passwordChange1: '',
      passwordChange2: '',
      resultEdit: '',
      form: {
        fullname: '',
        gender: '',
        email: '',
        phone: '',
        phonecode: '',
        job: '',
        companyAddress: '',
        npwp: '',
        companyName: '',
        countryId: '',
        provinceId: '',
        cityId: '',
        industryType: '',
        industryOthers: '',
        companyTradeRole: '',
        districtId: '',
        subdistrictId: '',
        postCode: '',
        companySize: '',
        termofpayment: '',
        salesname: '',
        yearlyRevenue: ''
      },
      filename: 'Choose File',
      photo: '',
      usersList: [],
      selectedGender: '',
      selectedSize: '',
      selectedCountry: '',
      selectedProvince: '',
      selectedCity: '',
      selectedDistrict: '',
      selectedSubdistrict: '',
      selectedPhoneCode: {
        phonecode: 0
      },
      selectedType: '',
      selectedSales: '',
      selectedRevenue: '',
      selectedIndustry: '',
      selectedTradeRole: '',
      optionCountry: [],
      optionProvince: [],
      optionCity: [],
      optionDistrict: [],
      optionSubdistrict: [],
      phoneOptions: [],
      genderOptions: [
        { id: 1, text: 'Male', value: 'M' },
        { id: 2, text: 'Female', value: 'F' }
      ],
      sizeOption: [{ id: '<50 people', name: '<50 people' },
        { id: '50 - 100 people', name: '50 - 100 people' },
        { id: '100 - 500 people', name: '100 - 500 people' },
        { id: '500 - 1000 people', name: '500 - 1000 people' },
        { id: '>1000 people', name: '>1000 people' }],
      optionRevenue: [
        { name: '<= IDR 50.000.000.000' },
        { name: '> IDR 50.000.000.000' }
      ],
      optionPosition: [
        { id: 1, text: 'Admin', value: 'USRA' },
        { id: 2, text: 'Staff', value: 'USRS' }
      ],
      optionUserStatus: [
        { id: 1, value: 1, text: 'Active' },
        { id: 2, value: 0, text: 'Not Active' }
      ]
    }
  },
  mounted () {
    this.fetchUsers()
    this.fetchCountries()
    this.getSalesList()
    this.getDialCode()
    this.initAccount()
  },
  mixins: [mixin, ConfigPassword],
  computed: {
    ...mapGetters({
      profile: 'auth/profile',
      users: 'settingUsers/users',
      error: 'settingUsers/error',
      isLoading: 'settingUsers/isLoading',
      company: 'settingCompany/company',
      companyError: 'settingCompany/error',
      companyIsLoading: 'settingCompany/isLoading',

      getListIndustry: 'auth/getListIndustry',
      errorGetListIndustry: 'auth/errorGetListIndustry',
      isLoadingGetListIndustry: 'auth/isLoadingGetListIndustry',

      getListTradeRole: 'auth/getListTradeRole',
      errorGetListTradeRole: 'auth/errorGetListTradeRole',
      isLoadingGetListTradeRole: 'auth/isLoadingGetListTradeRole',

      account: 'settingAccount/account',
      // eslint-disable-next-line no-dupe-keys
      errorAccount: 'settingAccount/error',
      // eslint-disable-next-line no-dupe-keys
      isLoading: 'settingAccount/isLoading',

      updateChangePassword: 'settingAccount/changePassword',
      isLoadingChangePassword: 'settingAccount/isLoadingChangePassword',
      errorChangePassword: 'settingAccount/errorChangePassword',

      editAccount: 'settingAccount/editAccount',
      isLoadingEditAccount: 'settingAccount/isLoadingEditAccount',
      errorEditAccount: 'settingAccount/errorEditAccount',

      countryList: 'settingCompany/countries',
      isErrorCountries: 'settingCompany/error',
      countriesIsLoading: 'settingCompany/countriesIsLoading',

      cityBycountries: 'settingCompany/cityBycountries',
      isErrcityBycountries: 'settingCompany/isErrcityBycountries',
      isLoadingcityBycountries: 'settingCompany/isLoadingcityBycountries',

      getProvincesByCountryId: 'city/getProvincesByCountryId',
      isLoadingProvincesByCountryId: 'city/isLoadingProvincesByCountryId',
      errorProvincesByCountryId: 'city/errorProvincesByCountryId',

      cityByProvinceId: 'city/getCityByProvinceId',
      isLoadingCityByProvinceId: 'city/isLoadingCityByProvinceId',
      errorCityByProvinceId: 'city/errorCityByProvinceId',

      districtByCityId: 'city/getDistrictByCityId',
      isLoadingDistrictByCityId: 'city/isLoadingDistrictByCityId',
      errorDistrictByCityId: 'city/errorDistrictByCityId',

      subdistrictByDistrictId: 'city/getSubdistrictByDistrictId',
      isLoadingSubdistrictByDistrictId: 'city/isLoadingSubdistrictByDistrictId',
      errorSubdistrictByDistrictId: 'city/errorSubdistrictByDistrictId',

      salesList: 'sales/items',
      isLoadingSales: 'sales/isLoading',
      errorSalesList: 'sales/error',

      city: 'city/city',
      // eslint-disable-next-line no-dupe-keys
      error: 'city/error',
      // eslint-disable-next-line no-dupe-keys
      isLoading: 'city/isLoading',

      dialcode: 'auth/dialcode',
      isLoadingDialcode: 'auth/isLoadingDialcode'
    })
  },
  methods: {
    formatNpwp (value) {
      value = value.replace(/[A-Za-z\W\s_]+/g, '')
      let split = 6
      const dots = []

      for (let i = 0, len = value.length; i < len; i += split) {
        split = i >= 2 && i <= 6 ? 3 : i >= 8 && i <= 12 ? 4 : 2
        dots.push(value.substr(i, split))
      }

      const temp = dots.join('.')
      let npwp = temp.length > 12 ? `${temp.substr(0, 12)}-${temp.substr(12, 7)}` : temp

      this.form.npwp = npwp
    },
    removeZeroFirstChar (phoneString) {
      let str = phoneString ? phoneString.toString() : null
      if (phoneString) {
        if (str.charAt(0) === '+') {
          str = str.substring(3) // remove first character
        }

        if (str.charAt(0) === '0') {
          str = str.substring(1) // remove first character
        } else if (str.charAt(0) === '6' && str.charAt(1) === '2') {
          str = str.substring(2)
        }
      }
      return `${str}`
    },
    initialSetdata (data) {
      this.optionCity = []
      this.$store.dispatch('settingCompany/FETCH_CITY_BY_COUNTRIES', data.countryId).then(() => {
        this.optionCity = this.cityBycountries.data
        this.cityBycountries.data.filter((item) => {
          if (item.id === data.cityId) {
            this.selectedCity = item
          }
        })
      })
      this.selectedPhoneCode.phonecode = +data.phonecode
      this.form.fullname = data.fullname
      this.form.gender = data.gender
      this.form.email = data.email
      this.photo = data.photo ? this.getImageAWS(data.photo) : ''
      this.form.phone = data.phone
      this.form.phonecode = data.phonecode
      this.form.job = data.job
      this.form.companyAddress = data.companyAddress
      this.form.npwp = data.npwp || ''
      this.form.companyName = data.companyName || data.compname
      this.form.countryId = data.countryId || ''
      this.form.provinceId = data.provinceId || 0
      this.form.cityId = data.cityId || ''
      this.form.industryType = data.industryType || ''
      this.form.industryOthers = data.industryOthers || ''
      this.form.companyTradeRole = data.companyTradeRole || ''
      this.form.districtId = data.districtId || 0
      this.form.subdistrictId = data.subdistrictId || 0
      this.form.postCode = data.postCode || ''
      this.form.companySize = data.companySize || ''
      this.form.companyAddress = data.companyAddress || ''
      this.form.npwp = data.npwp || ''
      this.form.phone = data.phone
      this.form.termofpayment = data.termofpayment
      this.form.salesname = data.salesname
      this.form.yearlyRevenue = data.yearlyRevenue
      this.selectedGender =
        data.gender === 'F'
          ? { id: 1, text: 'Female', value: 'F' }
          : { id: 1, text: 'Male', value: 'M' }
      this.sizeOption.filter((item) => {
        if (item.id === data.companySize) {
          this.selectedSize = item
        }
      })
      this.selectedCountry = { id: data.countryId, name: data.countryName } || ''
      this.selectedProvince = { id: data.provinceId, name: data.provinceName } || ''
      // this.selectedCity = { id: data.cityId, name: data.cityName } || ''
      this.selectedDistrict = { id: data.districtId, name: data.districtName } || ''
      this.selectedSubdistrict = { id: data.subdistrictId, name: data.subdistrictName } || ''
      this.selectedRevenue = { id: 1, name: data.yearlyRevenue } || ''
      this.selectedSales = { id: 1, name: data.salesname }
      this.selectedType = { id: 1, name: data.industryType }
      this.selectedIndustry = this.getListIndustry ? this.getListIndustry.find(el => el.name === data.industryType) : ''
      this.selectedTradeRole = this.getListTradeRole ? this.getListTradeRole.find(el => el.name === data.companyTradeRole) : ''
    },
    invite () {
      this.$eventHub.$emit('dialog-setting-invite', {compName: this.form.companyName})
    },
    selectProfilePict () {
      document.getElementById('fileUploadProfilePicture').click()
    },
    clearText (text, type) {
      this.pass_alert_msg = text
      this.isUpdatedPass = type
      this.resetFormPwd()
    },
    resetFormPwd () {
      this.formPassword.resetpwd = ''
      this.formPassword.confpwd = ''
      setTimeout(() => (this.pass_alert_msg = ''), 2000)
      this.isUpdatedPass = false
      this.$validator.reset()
    },
    async changePassword () {
      this.error_msg = ''
      if (this.formPassword.resetpwd === this.formPassword.confpwd) {
        const payload = {
          userPassword: this.formPassword.resetpwd,
          userPasswordConfirm: this.formPassword.confpwd
        }
        this.submitted = true
        await this.$store.dispatch('settingAccount/CHANGE_PASSWORD', payload)

        setTimeout(() => {
          this.fetchAccount()
        }, 2000)
      }
    },
    getSalesList () {
      this.$store.dispatch('sales/GET_SALES_LIST')
    },
    togglePassword1: function () {
      if (this.fieldTypePass1 === 'password') {
        this.fieldTypePass1 = 'text'
      } else {
        this.fieldTypePass1 = 'password'
      }
    },
    togglePassword2: function () {
      if (this.fieldTypePass2 === 'password') {
        this.fieldTypePass2 = 'text'
      } else {
        this.fieldTypePass2 = 'password'
      }
    },
    async toEditAccount () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.dispatch('settingAccount/EDIT_ACCOUNT', this.form).then(() => {
            if (this.errorEditAccount) {
              this.resultEdit = this.errorEditAccount.data.message
            } else {
              this.resultEdit = 'success'
              this.fetchAccount()
            }
          })
        }
      })
    },
    async fetchUsers () {
      await this.$store.dispatch('settingUsers/FETCH_USERS')
    },
    async fetchAccount () {
      await this.$store.dispatch('settingAccount/FETCH_ACCOUNT').then(() => {
        if (this.account) {
          this.initialSetdata(this.account)
        }
      })
    },
    async getIndustryList () {
      await this.$store.dispatch('auth/GET_LIST_INDUSTRY')
    },
    async getTradeRoleList () {
      await this.$store.dispatch('auth/GET_LIST_TRADE_ROLE')
    },
    async initAccount () {
      await this.getIndustryList()
      await this.getTradeRoleList()
      await this.fetchAccount()
    },
    inputSelectGender () {
      this.form.gender = this.selectedGender.value
    },
    inputSelectPhoneCode () {
      this.form.phonecode = this.selectedPhoneCode.phonecode
    },
    inputSelectProvince () {
      this.form.provinceId = this.selectedProvince.id
    },
    inputSelectDistrict () {
      this.form.districtId = this.selectedDistrict.id
    },
    inputSelectSubdistrict () {
      this.form.subdistrictId = this.selectedSubdistrict.id
    },
    inputSelectType () {
      this.form.industryType = this.selectedType.name
    },
    inputSelectYearlyRevenue () {
      this.form.yearlyRevenue = this.selectedRevenue.name
    },
    async getDialCode () {
      await this.$store.dispatch('auth/FETCH_DIAL_COUNTRY_CODE')
      await this.modifyDialCode()
    },
    async fetchCountries () {
      await this.$store.dispatch('settingCompany/FETCH_COUNTRIES')
      await this.modifyCountry()
    },
    modifyCountry () {
      return new Promise(resolve => {
        if (this.countryList) {
          this.optionCountry = this.countryList.data
        }
        return resolve()
      })
    },
    positionSelect (selected, i) {
      this.usersList[i].selectedPosition = selected
      this.usersList[i].codeusertype = selected.value
    },
    userSelectStatus (selected, i) {
      this.usersList[i].statverif = selected.value
      this.usersList[i].selectedUserStatus = selected
    },
    modifyProvince () {
      return new Promise(resolve => {
        if (this.getProvincesByCountryId) {
          this.optionProvince = this.getProvincesByCountryId
        }
        return resolve()
      })
    },
    handleFileUpload () {
      this.photo = this.$refs.fileDocument.files[0]
      this.filename = this.$refs.fileDocument.files[0].name
      this.upload_error = ''
      this.uploaded_msg = ''
      let reader = new FileReader()
      reader.addEventListener(
        'load',
        function () {
          this.photo = reader.result
        }.bind(this),
        false
      )
      if (this.photo) {
        if (/\.(jpe?g|png|gif)$/i.test(this.photo.name)) {
          reader.readAsDataURL(this.photo)
        }
      }
    },
    async uploadPhoto () {
      let formData = new FormData()
      formData.append('fileImage', this.$refs.fileDocument.files[0])
      this.submitted = true
      if (this.$refs.fileDocument.files[0].size > 5000000) {
        this.upload_error = 'Your file exceeded maximum requirement file'
      } else {
        await this.$store.dispatch('settingAccount/UPLOAD_PHOTO', formData)
        this.upload_error = ''
        this.fetchAccount()
        setTimeout(() => {
          this.uploaded_msg = this.account.photo
            ? 'Profile picture has been succesfully uploaded'
            : ''
        }, 1000)
      }
    },
    // modifyCity () {
    //   return new Promise(resolve => {
    //     if (this.cityBycountries) {
    //       this.optionCity = this.cityBycountries.data // ganti by provID
    //     }
    //     return resolve()
    //   })
    // },
    modifyDistrict () {
      return new Promise(resolve => {
        if (this.districtByCityId) {
          this.optionDistrict = this.districtByCityId
        }
        return resolve()
      })
    },
    modifySubdistrict () {
      return new Promise(resolve => {
        if (this.subdistrictByDistrictId) {
          this.optionSubdistrict = this.subdistrictByDistrictId
        }
        return resolve()
      })
    },
    modifyDialCode () {
      return new Promise(resolve => {
        if (this.dialcode) {
          this.phoneOptions = this.dialcode.data
        }
        return resolve()
      })
    },
    customPhoneLabel ({ phonecode }) {
      return `+${phonecode}`
    }
  },
  watch: {
    selectedSize (data) {
      if (data) {
        this.form.companySize = data.id
      }
    },
    editAccount (data) {
      if (data) {
        if (data.status === 200) {
          this.resultEdit = 'success'
        } else {
          this.resultEdit = data.data.message
        }
      }
    },
    account (data) {
      if (data) {
        this.initialSetdata(data)
      }
    },
    async selectedCountry (data) {
      this.optionCity = []
      this.form.cityId = ''
      this.selectedCity = ''
      if (data) {
        await this.$store.dispatch('settingCompany/FETCH_CITY_BY_COUNTRIES', data.id)
        this.optionCity = this.cityBycountries.data
        this.form.countryId = data.id
      }
    },
    // async selectedProvince (data) {
    //   if (data) {
    //     await this.$store.dispatch('city/FETCH_CITY_BY_PROVINCE', data.id)
    //   }
    //   this.modifyCity()
    // },
    async selectedCity (data) {
      this.form.cityId = this.selectedCity.id
    },
    async selectedDistrict (data) {
      if (data) {
        await this.$store.dispatch(
          'city/FETCH_SUBDISTRICT_BY_DISTRICT',
          data.id
        )
      }
      this.modifySubdistrict()
    },
    selectedIndustry (data) {
      if (data) {
        this.form.industryType = data.name
      }
    },
    selectedTradeRole (data) {
      if (data) {
        this.form.companyTradeRole = data.name
      }
    },
    users (data) {
      if (data) {
        this.usersList = data
        this.usersList.forEach(el => {
          el.selectedPosition = {
            id: 1,
            value: el.codeusertype,
            text: el.codeusertype === 'USRA' ? 'Admin' : 'Staff'
          }
          el.selectedUserStatus = {
            id: 1,
            value: el.statverif,
            text: el.statverif === 1 ? 'Active' : 'Not Active'
          }
        })
      }
    },
    updateChangePassword (data) {
      if (data) {
        this.clearText(data.message, true)
      }
    },
    dialcode (data) {
      this.phoneOptions = data.data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/settings/Account.vue